import React, { useState } from 'react'
import {
  Button,
  Container,
  Spinner,
  XStack,
  YStack,
  shadowStandard,
  useDebounce,
} from '@my/ui'
import { MainLayout, Meta, NoAccess, SectionTitle } from 'app/components'
import { Chat, User } from 'app/types'
import { NoResults } from 'app/features/shared/components'
import { ChatCard, ChatSearch } from '../../components'

export interface ChatsScreenProps {
  HeaderComponent?: React.ReactNode
  user: User | null
  searchTerm: string
  onSearchTermChange: (searchTerm: string) => void
  userChats: Chat[]
  userChatsLoading: boolean
  userChatsFetchingMore: boolean
  fetchMore: () => void
  hasMore: boolean
}

export const ChatsScreen = (props: ChatsScreenProps) => {
  const [searchTerm, setSearchTerm] = useState(props.searchTerm)
  const debouncedSearchTermChange = useDebounce(props.onSearchTermChange, 250)

  const handleSearchTermChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm)
    debouncedSearchTermChange(newSearchTerm)
  }
  return (
    <MainLayout>
      <Meta title="DMs" />
      {props.HeaderComponent && props.HeaderComponent}
      {!props.user && (
        <Container flex={1} py="$3.5" gap="$2" gutter size="sm" spaceTop spaceBottom>
          <NoAccess title="You must Sign In or Sign Up to Student Saviour to access chat" />
        </Container>
      )}
      {props.user && (
        <Container flex={1} gap="$3.5" gutter size="sm" spaceTop spaceBottom>
          <SectionTitle>DMs</SectionTitle>
          <YStack p="$3.5" gap="$3.5" bg="$white" br="$3" $gtSm={{ p: '$6' }} {...shadowStandard}>
            <ChatSearch query={searchTerm} onSearchChange={handleSearchTermChange} />

            {props.userChats.length === 0 && !props.userChatsLoading && (
              <NoResults
                text="Sorry, You have no messages"
                caption="But don’t worry, to start chatting, Direct message someone from their profile!"
              />
            )}
            {props.userChats &&
              props.userChats.length > 0 &&
              props.userChats.map((chat) => <ChatCard key={chat.id} {...chat} />)}

            {props.userChatsLoading && (
              <YStack jc="center" ai="center" minHeight={100} w="100%" flex={1}>
                <Spinner size="large" color="$black" />
              </YStack>
            )}

            {props.hasMore && (
              <XStack w="100%" jc="center" ai="center">
                <Button
                  onPress={props.fetchMore}
                  theme="primary"
                  loading={props.userChatsFetchingMore}
                >
                  Load more
                </Button>
              </XStack>
            )}
          </YStack>
        </Container>
      )}
    </MainLayout>
  )
}
